import styled, { css } from 'styled-components';
import { Menu } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';

const commonItemStyles = css`
  color: ${COLORS.GREY_DARK};
  padding: 0.625rem 1rem;
  ${pickThemeFontStyles('15', '20', 'NORMAL')};
  &.ant-menu-item-selected {
    ${pickThemeFontStyles('15', '20', 'BOLD')};
  }

  &:hover,
  &.ant-menu-item-selected {
    color: ${COLORS.ORANGE_PRIMARY};

    &::after {
      height: 0.25rem;
      background-color: ${COLORS.ORANGE_PRIMARY};
      width: 100%;
      transform: translateX(-1rem);
    }
  }

  &::after {
    height: 0.25rem;
  }
`;

export const StyledMenu = styled(Menu)`
  && .ant-menu-item {
    ${commonItemStyles}
  }

  &&&.ant-menu-submenu-active {
    color: ${COLORS.ORANGE_PRIMARY};

    &::after {
      height: 0.25rem !important;
      width: 100%;
      transform: translateX(-1rem);
      background-color: ${COLORS.ORANGE_PRIMARY};
    }
  }

  && .ant-menu-submenu-title {
    ${commonItemStyles}

    &:hover,
      color: ${COLORS.ORANGE_PRIMARY};

    &::after {
      height: 0.25rem;
      width: 100%;
      transform: translateX(-1rem);
      background-color: ${COLORS.ORANGE_PRIMARY};
    }
  }
`;
